"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var GroupResource = /** @class */ (function (_super) {
    tslib_1.__extends(GroupResource, _super);
    function GroupResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupResource.endpoint = '/groups';
    GroupResource.MODEL_NAME = 'group';
    return GroupResource;
}(base_1.default));
exports.default = GroupResource;
//# sourceMappingURL=group.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/group.js
// module id = vCY7
// module chunks = 0